import { Tooltip } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { MdOutlineFilterNone } from 'react-icons/md';
import { LoadingSpinner } from '../../../components';

const ReportByEventMobile = (props) => {
  const {showEvents,isLoading,handleOpen} = props;
  return (
    <div className='w-full max-w-md mx-auto p-1'>
      {isLoading ? (
         <LoadingSpinner />
      ) : (
        <div className='flex flex-col'>
          {
          showEvents.map((el,i) => {
            return (
              <div key={i} className='relative border border-gray-200 py-2 mb-3 bg-white shadow-md rounded-lg dark:bg-custom_dark_primary2 dark:border-custom_dark_primary px-1'>
                <div className='flex flex-col items-center space-x-4 mb-1'>
                  <span className='text-sm font-semibold dark:text-customWhite'>{el.leagueName}</span>
                  <span className='text-xs text-customFontGold font-semibold'>
                    {moment(el.eventDate).format("YYYY-MM-DD")} / {moment(el.eventTime).format("hh:mm a")}</span>
                </div>
                <div className='w-full flex text-customForeColor dark:text-customWhite font-bold'>
                  <div className='w-[60%] ml-3'>
                    <span className='text-xs'>Content</span>
                  </div>
                  <div className='w-[20%]'>
                    <span className='text-xs'>Sell</span>
                  </div>
                    <div className='w-[20%]'>
                    <span className='text-xs'>Buy</span>
                  </div>
                </div>
                <div className='w-full flex text-customFontVoilet font-bold'>
                  <div className='w-[60%] ml-3'>
                    <span className='text-xs'>{el.homeTeam}</span>
                  </div>
                  <div className='w-[20%]'>
                    <span className='text-xs'>{el.homeSaleAmount}</span>
                  </div>
                    <div className='w-[20%]'>
                    <span className='text-xs'>{el.homePurchaseAmount}</span>
                  </div>
                </div>
                <div className='w-full flex text-customFontGreen font-bold'>
                  <div className='w-[60%] ml-3'>
                    <span className='text-xs'>{el.awayTeam}</span>
                  </div>
                  <div className='w-[20%]'>
                    <span className='text-xs'>{el.awaySaleAmount}</span>
                  </div>
                   <div className='w-[20%]'>
                    <span className='text-xs'>{el.awayPurchaseAmount}</span>
                  </div>
                </div>
                <div className='w-full flex bg-gray-100 dark:bg-custom_dark_background dark:text-customWhite font-bold py-1'>
                   <div className='w-[40%] ml-3'>
                    <span className='text-xs'>Total Difference</span>
                  </div>
                  <div className='w-[60%] mr-3'>
                    <span className='text-xs'>{el.bodyDifferenceAmount} ({el.homeTeam})</span>
                  </div>
                </div>
                <div className='flex text-customFontVoilet font-bold'>
                 <div className='w-[60%] ml-3'>
                    <span className='text-xs'>Over</span>
                  </div>
                  <div className='w-[20%]'>
                    <span className='text-xs'>{el.overSaleAmount}</span>
                  </div>
                   <div className='w-[20%]'>
                    <span className='text-xs'>{el.overPurchaseAmount}</span>
                  </div>
                </div>
                <div className='flex text-customFontGreen font-bold'>
                <div className='w-[60%] ml-3'>
                    <span className='text-xs'>Under</span>
                  </div>
                  <div className='w-[20%]'>
                    <span className='text-xs'>{el.underSaleAmount}</span>
                  </div>
                   <div className='w-[20%]'>
                    <span className='text-xs'>{el.underPurchaseAmount}</span>
                  </div>
                </div>
                <div className='flex bg-gray-100 dark:bg-custom_dark_background dark:text-customWhite font-bold py-1'>
                  <div className='w-[40%] ml-3'>
                    <span className='text-xs'>Total Difference</span>
                  </div>
                  <div className='w-[60%] mr-3'>
                    <span className='text-xs'>{el.goalDifferenceAmount} (Over)</span>
                  </div>
                </div>
                <div className='flex justify-center items-center mt-2'>
                  <button onClick={() => handleOpen(el.rapidEventId)} className='flex items-center bg-customFontGreen text-xs text-white px-2 py-1 rounded gap-1'>
                    <MdOutlineFilterNone className="text-xs" /> Purchase
                  </button>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ReportByEventMobile